// SCROLL
//
//
//
//
//
//
export function initMetaScroll() {




  ////////////////////////////////
  // Scrolltop (VANILLA)
  ////////////////////////////////

  const scrollToTopButton = document.querySelector('.scrolltop');
  const windowHeight = window.innerHeight;
  let isButtonVisible = false;

  function debounce(func, wait, immediate) {
      let timeout;
      return function () {
          const context = this, args = arguments;
          const later = function () {
              timeout = null;
              if (!immediate) func.apply(context, args);
          };
          const callNow = immediate && !timeout;
          clearTimeout(timeout);
          timeout = setTimeout(later, wait);
          if (callNow) func.apply(context, args);
      };
  }

  const checkScroll = debounce(function () {
      const scrollPos = window.scrollY;
      if (scrollPos > windowHeight * 0.2) {
          if (!isButtonVisible) {
              gsap.to(scrollToTopButton, {visibility: 'visible', opacity: 1, duration: 0.3});
              isButtonVisible = true;
          }
      } else {
          if (isButtonVisible) {
              gsap.to(scrollToTopButton, {visibility: 'hidden', opacity: 0, duration: 0.3});
              isButtonVisible = false;
          }
      }
  }, 50);

  const debouncedCheckScroll = debounce(checkScroll, 50);
  window.addEventListener('scroll', debouncedCheckScroll);

  // Initial check to see if the button should be visible
  checkScroll();

  // Event for clicking the "scroll to top" button
  scrollToTopButton.addEventListener('click', function () {
      window.scrollTo(0, 0);
  });




////////////////////////////////
// SCROLL LOCK UTILITIES (VANILLA)
//////////////////////////////////
const ScrollManager = {
  scrollPosition: 0,
  scrollPreventionHandler: null,
  // ... methods
};

// Lock scrolling on the page
function lockScroll() {
  ScrollManager.scrollPosition = window.scrollY;
  document.documentElement.style.overflow = "hidden";
  document.body.style.position = "fixed";
  document.body.style.top = `-${ScrollManager.scrollPosition}px`;
  document.body.style.width = "100%";
}

// Unlock scrolling on the page
function unlockScroll() {
  document.documentElement.style.overflow = "";
  document.body.style.position = "";
  document.body.style.top = "";
  document.body.style.width = "";
  window.scrollTo(0, ScrollManager.scrollPosition);
}

// Prevent scrolling outside a specific container
function preventScrollOutside(container) {
  const containerElement = document.querySelector(container);
  if (containerElement) {
    ScrollManager.scrollPreventionHandler = (e) => {
      if (!containerElement.contains(e.target)) {
        e.preventDefault();
      }
    };
    document.addEventListener("scroll", ScrollManager.scrollPreventionHandler, { passive: false });
    document.addEventListener("touchmove", ScrollManager.scrollPreventionHandler, { passive: false });
  }
}

// Remove the scroll-prevention logic
function removeScrollPrevention() {
  if (ScrollManager.scrollPreventionHandler) {
    document.removeEventListener("scroll", ScrollManager.scrollPreventionHandler);
    document.removeEventListener("touchmove", ScrollManager.scrollPreventionHandler);
    ScrollManager.scrollPreventionHandler = null;
  }
}

// Make functions globally available
window.lockScroll = lockScroll;
window.unlockScroll = unlockScroll;
window.preventScrollOutside = preventScrollOutside;
window.removeScrollPrevention = removeScrollPrevention;

  console.log('meta-scroll loaded');

} // end initMetaScroll 